import { INVOICE_BILLING_STATUSES, type InvoiceBillingStatus } from '@vy/types';

const PAID_INVOICE_RESTRICTED_STATUSES: InvoiceBillingStatus[] = [
  INVOICE_BILLING_STATUSES.None,
  INVOICE_BILLING_STATUSES.Overdue,
  INVOICE_BILLING_STATUSES.PendingPayment,
];

type BillingStatusRestriction = {
  isDisabled: boolean;
  tooltipContent: string | undefined;
};

type BillingStatusRestrictionContext = {
  isApproved: boolean;
  isPaid: boolean;
  isCanceled: boolean;
};

export const getBillingStatusRestriction = (
  targetStatus: InvoiceBillingStatus,
  context: BillingStatusRestrictionContext,
): BillingStatusRestriction => {
  const cantMarkAsPaid = targetStatus === INVOICE_BILLING_STATUSES.Paid && !context.isApproved;
  const cantUncancel = context.isCanceled && context.isApproved;
  const cantChangeFromPaid = context.isPaid && PAID_INVOICE_RESTRICTED_STATUSES.includes(targetStatus);

  if (cantMarkAsPaid) {
    return { isDisabled: true, tooltipContent: 'Only approved invoices can be marked as paid' };
  }

  if (cantUncancel) {
    return { isDisabled: true, tooltipContent: 'Canceled approved invoices cannot be un-cancelled' };
  }

  if (cantChangeFromPaid) {
    return { isDisabled: true, tooltipContent: 'Paid invoices cannot be marked as Open, Overdue, or Pending' };
  }

  return { isDisabled: false, tooltipContent: undefined };
};
